/* Conference program filters.
 *
 * Client-side because Liquid is given no access to the query string and sessions
 * are not products, so there are no native storefront facets. Every session is in
 * the markup already; this only toggles visibility.
 *
 * The select options are built from the sessions on the page rather than hardcoded,
 * so a regenerated program with a new format or learning path needs no change here.
 */
(function () {
  'use strict';

  var FIELDS = ['format', 'path', 'level', 'day'];
  var LEVEL_ORDER = ['Novice', 'Intermediate', 'Advanced'];

  function init(root) {
    var sessions = Array.prototype.slice.call(root.querySelectorAll('.abz-cp__session'));
    if (!sessions.length) return;

    var selects = {};
    FIELDS.forEach(function (f) {
      selects[f] = root.querySelector('[data-abz-filter="' + f + '"]');
    });

    var panel = root.querySelector('[data-abz-filters]');
    var state = root.querySelector('[data-abz-active]');
    var count = root.querySelector('[data-abz-count]');
    var empty = root.querySelector('[data-abz-empty]');
    var clear = root.querySelector('[data-abz-clear]');
    var total = sessions.length;

    FIELDS.forEach(function (f) {
      var select = selects[f];
      if (!select) return;
      var values = [];
      sessions.forEach(function (s) {
        var v = s.getAttribute('data-' + f);
        if (v && values.indexOf(v) === -1) values.push(v);
      });
      if (f === 'level') {
        values.sort(function (a, b) { return LEVEL_ORDER.indexOf(a) - LEVEL_ORDER.indexOf(b); });
      } else if (f === 'day') {
        // day order is the order they appear in the program, which is chronological
      } else {
        values.sort();
      }
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v;
        o.textContent = v;
        select.appendChild(o);
      });
      select.addEventListener('change', apply);
    });

    if (clear) {
      clear.addEventListener('click', function () {
        FIELDS.forEach(function (f) { if (selects[f]) selects[f].value = ''; });
        apply();
        var first = selects[FIELDS[0]];
        if (first) first.focus();
      });
    }

    function apply() {
      var active = 0;
      var shown = 0;

      FIELDS.forEach(function (f) { if (selects[f] && selects[f].value) active++; });

      sessions.forEach(function (s) {
        var match = FIELDS.every(function (f) {
          var want = selects[f] ? selects[f].value : '';
          return !want || s.getAttribute('data-' + f) === want;
        });
        s.hidden = !match;
        if (match) shown++;
      });

      // a slot or a day with nothing left in it should not leave its time or
      // heading stranded above empty space
      Array.prototype.forEach.call(root.querySelectorAll('.abz-cp__slot'), function (slot) {
        slot.hidden = !slot.querySelector('.abz-cp__session:not([hidden])');
      });
      Array.prototype.forEach.call(root.querySelectorAll('.abz-cp__day'), function (day) {
        day.hidden = !day.querySelector('.abz-cp__slot:not([hidden])');
      });

      if (count) {
        count.textContent = active
          ? shown + ' of ' + total + ' sessions'
          : total + ' sessions';
      }
      // on a narrow screen the panel is usually shut, so the summary has to say
      // whether anything is filtering the program underneath it
      if (state) {
        state.textContent = active
          ? shown + ' of ' + total
          : '';
      }
      if (empty) empty.hidden = shown !== 0;
      if (clear) clear.hidden = active === 0;
    }

    // open at desktop widths, where the panel is a sidebar rather than a control,
    // and leave whatever the reader chose when the viewport is narrow
    if (panel) {
      var wide = window.matchMedia('(min-width: 990px)');
      var sync = function (mq) {
        if (mq.matches) {
          panel.open = true;
        } else if (panel.dataset.abzTouched !== 'true') {
          panel.open = false;
        }
      };
      panel.addEventListener('toggle', function () {
        if (!wide.matches) panel.dataset.abzTouched = 'true';
      });
      sync(wide);
      if (wide.addEventListener) {
        wide.addEventListener('change', sync);
      } else if (wide.addListener) {
        wide.addListener(sync);
      }
    }

    apply();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-abz-program]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
